import React from 'react';
import './SearchBar.css';


function SearchBar({searchForTracks}) {
    const [searchText, setSearchText] = React.useState('');
    const handleSearch = (e) =>{
        e.preventDefault();
        searchForTracks(searchText);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }
    return(
        <div className="SearchBar">
            <form onSubmit={handleSearch}>
                <input placeholder='Enter A Song Title'  onChange={handleInputChange} />
                <button type="submit">Search</button>
            </form>
        </div>
    );
}

export default SearchBar;